module.exports = __webpack_public_path__ + "static/img/16-3.196fb11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/16-3.jpg
// module id = Bg/f
// module chunks = 0